function EntityVersionCacheCtrl($scope, $controller, $state) {

    $scope.accountId = parseInt($state.params.accountId);

    $scope.selection = {
        type: "ACCOUNT",
        id: $scope.accountId,
    }

    $scope.onChange = function () {
        $scope.result = undefined;
    }

    $scope.get = function () {
        store.fetch({
            method: 'GET',
            path: `/entityversion?type=${$scope.selection.type}&id=${$scope.selection.id}`,
            success: (res) => {
                $scope.result = `Current version in cache: ${res}`;
            }
        })
    };

    $scope.setNow = function () {
        store.fetch({
            method: 'PUT',
            path: `/entityversion/setNow?type=${$scope.selection.type}&id=${$scope.selection.id}`,
            success: (res) => {
                $scope.result = `Current version in cache: ${res}`;
            }
        })
    }

    $scope.evict = function () {
        store.fetch({
            method: 'POST',
            path: `/entityversion/evict?type=${$scope.selection.type}&id=${$scope.selection.id}`,
            success: (res) => {
                $scope.result = `Cache entry for ${$scope.selection.type}_${$scope.selection.id} with value: ${res} evicted`;
            },
            error: (err) => {
                $scope.result = `Cache entry for ${$scope.selection.type}_${$scope.selection.id} not found`
            }
        })
    }

    $scope.evictAll = function () {
        store.fetch({
            method: 'POST',
            path: `/entityversion/evict?evictAll=true`,
            success: (res) => {
                $scope.result = `All entries in entity version cache are evicted`;
            },
        })
    };

}
